import z from "zod";
import ContactUsService from "../../../services/ContactUsService";
import { mapErrorsToFields } from "../../../utils";
const api = new ContactUsService();

export type State = {
  message?: string | null;
  success?: boolean;
  errors?: {
    name?: string[];
    email?: string[];
    subject?: string[];
    message?: string[];
    general?: string[];
  };
  defaultValues?: {
    name?: string;
    email?: string;
    subject?: string;
    message?: string;
    replayed?: boolean;
  };
};

const FormSchema = z.object({
  name: z.string().min(3, "Name is required.").max(255, "Name is too long."),
  email: z.email("Invalid email address.").min(1, "Email is required."),
  subject: z
    .string()
    .min(5, "Subject is required.")
    .max(255, "Subject is too long."),
  message: z
    .string()
    .min(5, "Message is required.")
    .max(1000, "Message is too long."),
});

export async function createContactUs(prevState: State, formData: FormData):Promise<State> {
     const defaultValues = {
    name: formData.get("name")?.toString(),
    email: formData.get("email")?.toString(),
    subject: formData.get("subject")?.toString(),
    message: formData.get("message")?.toString(),
  
  };
  const validatedFields = FormSchema.safeParse(defaultValues);
  console.log({validatedFields})
  if (!validatedFields.success) {
    return {
      message: "Validation Error",
      success: false,
      errors: mapErrorsToFields(validatedFields.error),
      defaultValues:defaultValues,
    };
  }
 
  const result = await api.createContactUs(validatedFields.data);
  if (result.status === 201)
    return {
      message: "Your message has been sent successfully!",
      success: true,
      errors: {},
      defaultValues: {},
    };

  return {
    message: "Failed to send message. Please try again.",
    success: false,
    errors: {},
    defaultValues: defaultValues,
  };
}
